import React from "react";

import {bindActionCreators} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import {receiveError} from "../../api/http";
import moment from "moment";

import {Modal, Checkbox, message, Table, Tooltip, Select, Switch } from "antd";

import "./index.scss";

const {Option} = Select;

function onChange(value) {
    console.log(`selected ${value}`);
}

function onSearch(val) {
    console.log('search:', val);
}

class AdminSyncReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            syncList: [],
            pageSize: 50,
            page: 1,
            total: 0,
            showOnlyActive: false,
            userList: [],
            accountList: [],
            userId: "",
            accountId: "",
            userStatus: ""
        };
        this.onChangeUser = this.onChangeUser.bind(this);
        this.onChangeAccount = this.onChangeAccount.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);
    }

    onChangeUser(value) {
        console.log(`selected ${value}`);
        this.setState({
            userId: value,
            loading: true,
        },()=>{
            this.getSyncReportData();
        });
    }
    onChangeStatus(value) {
        console.log(`selected ${value}`);
        this.setState({
            userStatus: value,
            loading: true,
        },()=>{
            this.getSyncReportData();
        });
    }

    onChangeAccount(value) {
        console.log(`selected ${value}`);
        this.setState({
            accountId: value,
            loading: true,
        },()=>{
            this.getSyncReportData();
        });

    }
    componentDidMount() {
        this.setState({
            loading: true,
        });
        CloudFlyerAPI.user_account
            .fetchAllUsers(0, 0, this.state.searchUser)
            .then(({data}) => {
                var res = data.data;
                console.log(data)
                var arr = {
                    username: "All",
                    id: ""
                }
                res.unshift(arr)
                this.setState({
                    loading: false,
                    userList: res,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });

        CloudFlyerAPI.user_account
            .fetchAllAccounts(0, 0, this.state.accountName)
            .then(({data}) => {
                console.log(data, "accountList")
                var res = data.data
                var arr = {
                    name: "All",
                    id: ""
                }
                res.unshift(arr)
                this.setState({
                    loading: false,
                    accountList: res,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
        this.getSyncReportData();
        /*CloudFlyerAPI.user_account.ActiveStatus({
            active: this.state.userStatus
        })
            .then(function (response) {
                message.success('User Added Successfully!')
            })
            .catch(function (err) {
                message.error('Something went wrong!')
            })*/
    }
    getSyncReportData(){

        CloudFlyerAPI.sync
            .fetchAllSync(
                this.state.showOnlyActive,
                this.state.pageSize,
                this.state.page,
                this.state.userId,
                this.state.accountId
            )
            .then(({data}) => {
                this.setState({
                    loading: false,
                    syncList: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });

    }

    onPageChange = (page) => {
        this.setState({page: page, loading: true});

        CloudFlyerAPI.sync
            .fetchAllSync(this.state.showOnlyActive, this.state.pageSize, page,
                this.state.userId,
                this.state.accountId)
            .then(({data}) => {
                this.setState({
                    loading: false,
                    syncList: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    };

    on_active_change = (showActive) => {
        this.setState({
            showOnlyActive: showActive,
            loading: true,
            page: 1,
        });
        CloudFlyerAPI.sync
            .fetchAllSync(showActive, this.state.pageSize, 1,
                "",
                "")
            .then(({data}) => {
                this.setState({
                    loading: false,
                    syncList: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    };

    handleActivateClick = (syncId, active) => {

        let activateMessage = ""
        if (active) {
            activateMessage = "deactivate"
        } else {
            activateMessage = "activate"
        }

        CloudFlyerAPI
            .user_account
            .ActiveStatus({
                id: syncId,
                active: !active
            })
            .then(response => {
                message.success(`Sync Information ${activateMessage} successfully!`)
                this.getSyncReportData();
            })
            .catch(err => {
                message.error("Something went wrong.")
            })
    }

    render() {
        let directions = new Map();
        directions.set(1, "AWS to Wasabi");
        directions.set(2, "Wasabi to Wasabi");

        let status = new Map();
        status.set(true, "Active");
        status.set(false, "Inactive");

        const showActivateConfirm = (e, handleActivateClick, syncId, destination, active) => {
            //e.stopPropagation()
            let activateMessage = ""
            if (active) {
                activateMessage = "deactivate"
            } else {
                activateMessage = "activate"
            }

            Modal.confirm({
                title: `Are you sure you want to ${activateMessage} the ${destination} Sync?`,
                content:
                    "",
                onOk() {
                    handleActivateClick(syncId, active)
                }
            })
        }
        const {providers} = this.state;
        const {match} = this.props;
        const {user, history} = this.props;

        const columns = [
            {
                title: "User",
                dataIndex: "username",
                key: "username",
                ellipsis: {
                    showTitle: false,
                },
                render: (username) => (
                    <Tooltip placement="topLeft" title={username}>
                        {username}
                    </Tooltip>
                ),
                width: 150,
            },
            {
                title: "Account",
                dataIndex: "account",
                key: "account",
                width: 130,
            },
            {
                title: "Direction",
                dataIndex: "direction",
                key: "direction",
                width: 120,
            },
            {
                title: "Source Region",
                dataIndex: "sourceRegion",
                key: "sourceRegion",
                ellipsis: {
                    showTitle: false,
                },
                render: (sourceRegion) => (
                    <Tooltip placement="topLeft" title={sourceRegion}>
                        {sourceRegion}
                    </Tooltip>
                ),
                width: 130,
            },
            {
                title: "Source Bucket",
                dataIndex: "source",
                key: "source",
                ellipsis: {
                    showTitle: false,
                },
                render: (source) => (
                    <Tooltip placement="topLeft" title={source}>
                        {source}
                    </Tooltip>
                ),
                width: 130,
            },
            {
                title: "Destination Region",
                dataIndex: "destinationRegion",
                key: "destinationRegion",
                ellipsis: {
                    showTitle: false,
                },
                render: (destinationRegion) => (
                    <Tooltip placement="topLeft" title={destinationRegion}>
                        {destinationRegion}
                    </Tooltip>
                ),
                width: 130,
            },
            {
                title: "Destination Bucket",
                dataIndex: "destination",
                key: "destination",
                ellipsis: {
                    showTitle: false,
                },
                render: (destination) => (
                    <Tooltip placement="topLeft" title={destination}>
                        {destination}
                    </Tooltip>
                ),
                width: 130,
            },
            {
                title: "Created Date",
                dataIndex: "date",
                key: "date",
                width: 100,
            },
            {
                title: "Status",
                dataIndex: "active",
                key: "active",
                width: 80,
            },
            {
                title: 'Active',
                dataIndex: 'activeData',
                key: 'activeData',
                ellipsis: {
                    showTitle: false,
                },
                render: activeData => (
                    <Switch
                        size="small"
                        checked={activeData.active}
                        onChange={e =>
                            showActivateConfirm(e, this.handleActivateClick, activeData.id, (activeData.source + " to " + activeData.destination), activeData.active)
                        }
                    />
                ),
                width: 80,
            }
        ];

        let data = this.state?.syncList?.map((t, index) => {
            return {
                key: t.id,
                username: t.user.username,
                account: t.user.account.name,
                direction: directions.get(t.sourceCloudAccount.cloudType),
                source: t.sourceBucket,
                sourceRegion: t.sourceRegion,
                destination: t.destinationBucket,
                destinationRegion: t.destinationRegion,
                date: moment(t.createDate).format("MM/DD/YYYY"),
                active: status.get(t.active),
                activeData: {
                    active: t.active,
                    source: t.sourceCloudAccount.name + ' > ' + t.sourceBucket,
                    destination: t.destinationCloudAccount.name + ' > ' + t.destinationBucket,
                    id: t.id
                }
            };
        });

        return (
            <div className="usersListdashboard">
                <div className="header">
                    <div className="left-wrapper">
                        <h2>Sync Report</h2>
                    </div>
                    <div className="right-wrapper">
                        User:
                        <Select
                            showSearch
                            style={{width: 200}}
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }
                            onChange={this.onChangeUser}
                        >
                            {
                                this.state.userList.map((data, index) => (
                                    <Option key={index} value={data.id}>{data.username}</Option>
                                ))
                            }
                        </Select>

                        &nbsp;&nbsp;&nbsp;&nbsp;Account:
                        <Select
                            showSearch
                            style={{width: 200}}
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }
                             onChange={this.onChangeAccount}
                        >
                            {
                                this.state.accountList.map((data, index) => (
                                    <Option key={index} value={data.id}>{data.name}</Option>
                                ))
                            }
                        </Select>

                        &nbsp;&nbsp;&nbsp;&nbsp;<Checkbox
                        checked={this.state.showOnlyActive}
                        onChange={(e) => this.on_active_change(e.target.checked)}
                    >
                        Show Only Active Sync
                    </Checkbox>
                    </div>
                </div>
                <div className="active-jobs-wrapper-sync">
                    <Table
                        loading={this.state.loading}
                        columns={columns}
                        dataSource={data}
                        pagination={{
                            onChange: this.onPageChange,
                            total: this.state.total,
                            current: this.state.page,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} items`,
                            pageSize: this.state.pageSize,
                        }}
                        scroll={{y: 600}}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(
    connect(
        ({auth}) => {
            let user = auth.user;
            return {
                ...user,
            };
        },
        (dispatch) => bindActionCreators({}, dispatch)
    )(AdminSyncReport)
);
